module.exports = __webpack_public_path__ + "static/img/checkout1.ce9ad82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/checkout1.png
// module id = 6U9R
// module chunks = 8